$(document).ready(function(){
  //filter tab js start
    $('.collection-filter-tab .filter_tab_item').on('click', function(){
        var datatab = $(this).attr('data-tab');
        $('.collection-filter-tab .filter_tab_item').removeClass('tab_active');
        $(this).addClass('tab_active');
        //console.log('clicked tab => ' + datatab );
          $('.feature-collection .tab-content').each(function() {
              var datacontent = $(this).attr('data-tab');
              if (datatab == datacontent) {
                  $(this).fadeIn();
                  if (['summer', 'autumn', 'winter', 'spring'].includes(datacontent.toLowerCase())) {
                      $('.selected_filter .active_fiter_text').text('SEASON - ' + datacontent);
                  } else {
                      $('.selected_filter .active_fiter_text').text(datacontent);
                  }
              } else {
                  $(this).fadeOut();
              }
          });
      if ($('body').hasClass('mobo_fiter_tab_open')) {
        $('.filter_tab_list').hide();
        $('body').removeClass('mobo_fiter_tab_open');
      }
    });
//for mobile function start
    $('.filter_mobo_toggle_icon').on('click', function(event) {
        event.stopPropagation(); // Prevent body click from firing
        $('.filter_tab_list').toggle().toggleClass('mobo_fiter_tab_active');
        $('body').toggleClass('mobo_fiter_tab_open');
    });

    $(document).on('click', function(event) {
        if ($('body').hasClass('mobo_fiter_tab_open')) {
            if (!$(event.target).closest('.filter_tab_list, .filter_mobo_toggle_icon').length) {
                // If click is outside .filter_tab_list and .filter_mobo_toggle_icon
                $('.filter_tab_list').hide().removeClass('mobo_fiter_tab_active');
                $('body').removeClass('mobo_fiter_tab_open');
            }
        }
    });


//for mobile function end
  
  //filter tab js end

  //terms & conditions tab js start
          //js for desktop start
            $('.terms-condition-tabs .desktop_content .tnc-tab__title').on('click', function(){
              var datatab = $(this).attr('data-tab');
              $('.terms-condition-tabs .tnc-tab__title').removeClass('tab_active');
              $(this).addClass('tab_active');
              //console.log('clicked tab => ' + datatab );
              $('.terms-condition-tabs .desktop_content .tab_content_wrap').each(function() {
                  var datacontent = $(this).attr('data-for');
                  if (datatab == datacontent) {
                      $(this).fadeIn();
                  } else {
                      $(this).fadeOut();
                  }
              });
            });
          //js for desktop end
          //js for mobile start
                  $('.terms-condition-tabs .block_content_mobo_wrap .tnc-tab__title').on('click', function() {
                    var datatab = $(this).attr('data-tab');
                    var $contentToToggle = $('.terms-condition-tabs .block_content_mobo_wrap .tab_content_wrap[data-for="' + datatab + '"]');
                  
                    // Toggle active class on the tab
                    if ($(this).hasClass('tab_active')) {
                      // If it's already active, just close the content and remove active class
                      $(this).removeClass('tab_active');
                      $contentToToggle.slideUp();
                    } else {
                      // Remove active class from all tabs and hide all contents
                      $('.terms-condition-tabs .tnc-tab__title').removeClass('tab_active');
                      $('.terms-condition-tabs .block_content_mobo_wrap .tab_content_wrap').slideUp();
                  
                      // Add active class to the clicked tab and show the corresponding content
                      $(this).addClass('tab_active');
                      $contentToToggle.slideDown();
                    }
                  
                   // console.log('clicked tab => ' + datatab);
                  });
  
          //js for mobile end
  //terms & conditions tab js end
  
});